/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * timestamping status
 */
export enum TimestampingStatus {
    SUCCESS = 'SUCCESS',
    ERROR_CODE_TIMESTAMP_REQUEST_TIMED_OUT = 'ERROR_CODE_TIMESTAMP_REQUEST_TIMED_OUT',
    ERROR_CODE_MALFORMED_TIMESTAMP_SERVER_URL = 'ERROR_CODE_MALFORMED_TIMESTAMP_SERVER_URL',
    ERROR_CODE_TIMESTAMP_UNINITIALIZED = 'ERROR_CODE_TIMESTAMP_UNINITIALIZED',
    ERROR_CODE_INTERNAL = 'ERROR_CODE_INTERNAL',
    UNKNOWN = 'UNKNOWN',
}